import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  exportAttendanceEmployeeByDay,
  exportAttendanceEmployeeByRangeDay,
  exportAttendanceTotalEmployeeByRangeDay,
  getAttendanceEmployeeByDay,
  getAttendanceEmployeeByRangeDay,
  getAttendanceTotalEmployeeByRangeDay,
} from '@/apis/attendanceEmployee'
import { apiHost } from '@/configs/api'
import useNotification from '@/hooks/useNotification'
import {
  ExportAttendanceEmployeeByDayRequest,
  ExportAttendanceEmployeeByRangeDayRequest,
  ExportAttendanceTotalEmployeeByRangeDayRequest,
  GetAttendanceEmployeeByDayRequest,
  GetAttendanceEmployeeByDayResponse,
  GetAttendanceEmployeeByRangeDayRequest,
  GetAttendanceEmployeeByRangeDayResponse,
  GetAttendanceTotalEmployeeByRangeDayRequest,
  GetAttendanceTotalEmployeeByRangeDayResponse,
} from '@/types/apis/attendanceEmployee'

export const useAttendanceEmployeeByDay = () => {
  const openNotification = useNotification()
  const { t } = useTranslation()

  const [responseAttendanceEmployee, setResponseAttendanceEmployee] = useState<GetAttendanceEmployeeByDayResponse>()
  const [responseAttendanceEmployeeLoading, setResponseAttendanceEmployeeLoading] = useState(false)
  const [exportEmployeeLoading, setExportEmployeeLoading] = useState(false)

  const [responseAttendanceEmployeeByRangeDay, setResponseAttendanceEmployeeByRangeDay] =
    useState<GetAttendanceEmployeeByRangeDayResponse>()
  const [responseAttendanceEmployeeByRangeDayLoading, setResponseAttendanceEmployeeByRangeDayLoading] = useState(false)
  const [exportEmployeeByRangeDayLoading, setExportEmployeeByRangeDayLoading] = useState(false)

  const [responseAttendanceTotalEmployee, setResponseAttendanceTotalEmployee] =
    useState<GetAttendanceTotalEmployeeByRangeDayResponse>()
  const [responseAttendanceTotalEmployeeLoading, setResponseAttendanceTotalEmployeeLoading] = useState(false)
  const [exportTotalEmployeeLoading, setExportTotalEmployeeLoading] = useState(false)

  const get = useCallback(async (request: GetAttendanceEmployeeByDayRequest) => {
    try {
      setResponseAttendanceEmployeeLoading(true)
      const res = await getAttendanceEmployeeByDay(request)
      setResponseAttendanceEmployee(res)
    } finally {
      setResponseAttendanceEmployeeLoading(false)
    }
  }, [])

  const exportExcel = async (request: ExportAttendanceEmployeeByDayRequest) => {
    try {
      setExportEmployeeLoading(true)
      // TODO: call API and open url in a new tab
      const result = await exportAttendanceEmployeeByDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
      // TODO:
    } finally {
      setExportEmployeeLoading(false)
    }
  }

  const getEmployeeByRangeDay = useCallback(
    async (request: GetAttendanceEmployeeByRangeDayRequest) => {
      try {
        setResponseAttendanceEmployeeByRangeDayLoading(true)
        const res = await getAttendanceEmployeeByRangeDay(request)
        setResponseAttendanceEmployeeByRangeDay(res)
      } catch {
        setResponseAttendanceEmployeeByRangeDay(undefined)
        openNotification({
          type: 'error',
          description: t('components.pages.clientDevice.listReport.hooks.selectRangeDateFail'),
        })
      } finally {
        setResponseAttendanceEmployeeByRangeDayLoading(false)
      }
    },
    [openNotification, t]
  )

  const exportExcelEmployeeByRangeDate = async (request: ExportAttendanceEmployeeByRangeDayRequest) => {
    try {
      setExportEmployeeByRangeDayLoading(true)
      // TODO: call API and open url in a new tab
      const result = await exportAttendanceEmployeeByRangeDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
      // TODO:
    } finally {
      setExportEmployeeByRangeDayLoading(false)
    }
  }

  const getTotalEmployeeByRangeDay = useCallback(
    async (request: GetAttendanceTotalEmployeeByRangeDayRequest) => {
      try {
        setResponseAttendanceTotalEmployeeLoading(true)
        const res = await getAttendanceTotalEmployeeByRangeDay(request)
        setResponseAttendanceTotalEmployee(res)
      } catch {
        setResponseAttendanceTotalEmployee(undefined)
        openNotification({
          type: 'error',
          description: t('components.pages.clientDevice.listReport.hooks.selectRangeDateFail'),
        })
      } finally {
        setResponseAttendanceTotalEmployeeLoading(false)
      }
    },
    [openNotification, t]
  )

  const exportExcelTotalEmployeeByRangeDay = async (request: ExportAttendanceTotalEmployeeByRangeDayRequest) => {
    try {
      setExportTotalEmployeeLoading(true)
      // TODO: call API and open url in a new tab
      const result = await exportAttendanceTotalEmployeeByRangeDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
      // TODO:
    } finally {
      setExportTotalEmployeeLoading(false)
    }
  }

  return {
    getAttendanceEmployeeByDay: get,
    responseAttendanceEmployee,
    responseAttendanceEmployeeLoading,
    exportEmployeeLoading,
    exportExcelAttendanceEmployeeByDay: exportExcel,
    getEmployeeByRangeDay,
    responseAttendanceEmployeeByRangeDay,
    responseAttendanceEmployeeByRangeDayLoading,
    exportEmployeeByRangeDayLoading,
    exportExcelEmployeeByRangeDate,
    getTotalEmployeeByRangeDay,
    responseAttendanceTotalEmployee,
    responseAttendanceTotalEmployeeLoading,
    exportTotalEmployeeLoading,
    exportExcelTotalEmployeeByRangeDay,
  }
}
